export enum Title {
  BASIC_NURSING_CARE = 'Basic Nursing Care'
}
